<span style="color: red">{{ getFormatted() }}</span>